(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-range"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('size-range-component')) return;

    // "3-1/2 in (89 mm)" -> "3-1/2 in"; a size without inches stays as it is.
    const inches = (label) => String(label).replace(/ \([\d.]+ mm\)$/, '');

    class SizeRangeComponent extends HTMLElement {
      #timer = 0;
      #pointer = false;

      connectedCallback() {
        this.addEventListener('input', this.#onInput);
        this.addEventListener('pointerdown', this.#onPointerDown);
        this.addEventListener('keydown', this.#onKeyDown);
        this.addEventListener('focusin', this.#onFocusIn);
        this.addEventListener('focusout', this.#onFocusOut);
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.#onInput);
        this.removeEventListener('pointerdown', this.#onPointerDown);
        this.removeEventListener('keydown', this.#onKeyDown);
        this.removeEventListener('focusin', this.#onFocusIn);
        this.removeEventListener('focusout', this.#onFocusOut);
        clearTimeout(this.#timer);
      }

      get #handles() {
        return [...this.querySelectorAll('[data-size-range-input]')];
      }

      get #values() {
        return [...this.querySelectorAll('[data-size-range-values] input')];
      }

      // The handles may pass each other while dragged; the range is whichever is smaller to whichever is larger.
      #range() {
        const [a, b] = this.#handles.map((handle) => Number(handle.value));
        return [Math.min(a, b), Math.max(a, b)];
      }

      #render() {
        const [lo, hi] = this.#range();
        const values = this.#values;
        const last = values.length - 1;
        const from = inches(values[lo].dataset.label);
        const to = inches(values[hi].dataset.label);
        this.querySelector('[data-size-range-readout]').textContent = lo === hi ? from : `${from} – ${to}`;
        const track = this.querySelector('[data-size-range-track]');
        track.style.setProperty('--from', `${last ? (lo / last) * 100 : 0}%`);
        track.style.setProperty('--to', `${last ? (hi / last) * 100 : 100}%`);
        this.#handles.forEach((handle) => {
          handle.setAttribute('aria-valuetext', values[Number(handle.value)].dataset.label);
        });
      }

      #onInput = (event) => {
        if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-size-range-input]')) return;
        // The handle last moved stays on top, so it can be picked up again where the two meet.
        this.#handles.forEach((handle) => handle.classList.toggle('size-range__input--top', handle === event.target));
        this.#render();
      };

      /** The handles' change events, which the window listener below keeps from the filter form. */
      handleChange() {
        clearTimeout(this.#timer);
        if (this.#pointer) {
          this.#pointer = false;
          this.#apply();
        } else {
          this.#timer = setTimeout(() => this.#apply(), 500);
        }
      }

      // Ticks the sizes between the handles (none when they span everything) and lets the filter form submit.
      #apply() {
        const [lo, hi] = this.#range();
        const values = this.#values;
        const all = lo === 0 && hi === values.length - 1;
        let changed = false;
        values.forEach((input, index) => {
          const checked = !all && index >= lo && index <= hi;
          if (input.checked !== checked) {
            input.checked = checked;
            changed = true;
          }
        });
        const [first, second] = this.#handles;
        first.value = String(lo);
        second.value = String(hi);
        this.#render();
        if (changed) values[0].dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Pressing the rail moves the nearer handle there.
      #onPointerDown = (event) => {
        this.#pointer = true;
        const track = this.querySelector('[data-size-range-track]');
        if (event.target !== track) return;
        const rect = track.getBoundingClientRect();
        const last = this.#values.length - 1;
        const index = Math.round(Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1) * last);
        const nearest = this.#handles.reduce((a, b) =>
          Math.abs(Number(b.value) - index) < Math.abs(Number(a.value) - index) ? b : a
        );
        nearest.value = String(index);
        nearest.focus();
        this.#onInput({ target: nearest });
        this.#pointer = false;
        this.#apply();
      };

      #onKeyDown = () => {
        this.#pointer = false;
      };

      // A re-render while a handle has focus keeps its live position (assets/morph.js honours this marker).
      #onFocusIn = (event) => {
        if (event.target instanceof HTMLInputElement && event.target.matches('[data-size-range-input]')) {
          event.target.setAttribute('data-skip-value-update', 'true');
        }
      };

      #onFocusOut = (event) => {
        if (event.target instanceof HTMLInputElement && event.target.matches('[data-size-range-input]')) {
          event.target.removeAttribute('data-skip-value-update');
        }
      };
    }

    customElements.define('size-range-component', SizeRangeComponent);

    // The filter form listens for change events on the document while capturing, so a handle's own change would
    // submit before the hidden checkboxes are set. Stopped here first; the slider submits when it is ready.
    window.addEventListener(
      'change',
      (event) => {
        const handle = event.target;
        if (!(handle instanceof HTMLInputElement) || !handle.matches('[data-size-range-input]')) return;
        event.stopPropagation();
        const slider = handle.closest('size-range-component');
        if (slider instanceof SizeRangeComponent) slider.handleChange();
      },
      { capture: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spec-dropdown"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.specDropdown) return;

    const dropdownOf = (element) => element?.closest('[data-spec-dropdown]');
    const optionsOf = (list) => Array.from(list.querySelectorAll('[role="option"]'));

    const setActive = (list, option, scroll = true) => {
      list.querySelector('.spec-dropdown__option--active')?.classList.remove('spec-dropdown__option--active');
      if (!option) {
        list.removeAttribute('aria-activedescendant');
        return;
      }
      option.classList.add('spec-dropdown__option--active');
      list.setAttribute('aria-activedescendant', option.id);
      if (scroll) option.scrollIntoView({ block: 'nearest' });
    };

    const close = (dropdown, focusButton = false) => {
      const button = dropdown.querySelector('.spec-dropdown__button');
      const list = dropdown.querySelector('.spec-dropdown__list');
      dropdown.classList.remove('spec-dropdown--open', 'spec-dropdown--up');
      if (list) {
        list.hidden = true;
        setActive(list, null);
      }
      button?.setAttribute('aria-expanded', 'false');
      if (focusButton) button?.focus();
    };

    const closeOthers = (keep) => {
      document.querySelectorAll('.spec-dropdown--open').forEach((dropdown) => {
        if (dropdown !== keep) close(dropdown);
      });
    };

    const open = (dropdown) => {
      const button = dropdown.querySelector('.spec-dropdown__button');
      const list = dropdown.querySelector('.spec-dropdown__list');
      if (!button || !list || !optionsOf(list).length) return;
      closeOthers(dropdown);
      list.hidden = false;
      dropdown.classList.add('spec-dropdown--open');
      button.setAttribute('aria-expanded', 'true');
      // Open upward when the list would run off the bottom of the screen and there is room above.
      const box = dropdown.getBoundingClientRect();
      const height = list.getBoundingClientRect().height;
      dropdown.classList.toggle('spec-dropdown--up', box.bottom + height > window.innerHeight && box.top > height);
      setActive(list, list.querySelector('[aria-selected="true"]') || optionsOf(list)[0]);
      list.focus({ preventScroll: true });
    };

    const choose = (dropdown, option) => {
      const select = dropdown.querySelector('select');
      dropdown.querySelectorAll('[role="option"]').forEach((item) => item.setAttribute('aria-selected', String(item === option)));
      // Show the choice at once; a re-render that follows draws the same.
      const shown = dropdown.querySelector('.spec-dropdown__value');
      if (shown) shown.replaceChildren(...Array.from(option.childNodes, (node) => node.cloneNode(true)));
      close(dropdown, true);
      if (select && select.value !== option.dataset.value) {
        select.value = option.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    // Keep focus on the list while an option is pressed, so the press can complete.
    document.addEventListener('mousedown', (event) => {
      if (event.target instanceof Element && event.target.closest('.spec-dropdown__list')) event.preventDefault();
    });

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest('.spec-dropdown__button');
      if (button) {
        const dropdown = dropdownOf(button);
        if (dropdown.classList.contains('spec-dropdown--open')) close(dropdown, true);
        else open(dropdown);
        return;
      }
      const option = target?.closest('.spec-dropdown__option');
      if (option) {
        choose(dropdownOf(option), option);
        return;
      }
      closeOthers(null);
    });

    document.addEventListener('mouseover', (event) => {
      const option = event.target instanceof Element ? event.target.closest('.spec-dropdown__option') : null;
      if (option) setActive(option.closest('.spec-dropdown__list'), option, false);
    });

    let typed = '';
    let typedAt = 0;
    document.addEventListener('keydown', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest('.spec-dropdown__button');
      if (button && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        event.preventDefault();
        open(dropdownOf(button));
        return;
      }
      const list = target?.closest('.spec-dropdown__list');
      if (!list) return;
      const dropdown = dropdownOf(list);
      const options = optionsOf(list);
      const current = list.querySelector('.spec-dropdown__option--active');
      let index = options.indexOf(current);
      switch (event.key) {
        case 'ArrowDown':
          index = Math.min(options.length - 1, index + 1);
          break;
        case 'ArrowUp':
          index = Math.max(0, index - 1);
          break;
        case 'Home':
          index = 0;
          break;
        case 'End':
          index = options.length - 1;
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          if (current) choose(dropdown, current);
          return;
        case 'Escape':
          event.preventDefault();
          close(dropdown, true);
          return;
        case 'Tab':
          close(dropdown);
          return;
        default: {
          if (event.key.length !== 1 || event.ctrlKey || event.metaKey || event.altKey) return;
          // Type to jump to the next value starting with the letters typed.
          const now = Date.now();
          typed = now - typedAt > 700 ? event.key.toLowerCase() : typed + event.key.toLowerCase();
          typedAt = now;
          const start = typed.length > 1 ? index : index + 1;
          const order = options.slice(start).concat(options.slice(0, start));
          const match = order.find((option) => option.textContent.trim().toLowerCase().startsWith(typed));
          if (!match) return;
          index = options.indexOf(match);
        }
      }
      event.preventDefault();
      setActive(list, options[index]);
    });

    document.addEventListener('focusout', (event) => {
      const list = event.target instanceof Element ? event.target.closest('.spec-dropdown__list') : null;
      const dropdown = dropdownOf(list);
      if (dropdown && !dropdown.contains(event.relatedTarget)) close(dropdown);
    });

    // For selects filled from script: (re)build the button and list from the select's options.
    const content = (option) => {
      const nodes = [];
      const iconId = option?.dataset.icon;
      const template = iconId ? document.querySelector(`template[data-spec-icon="${iconId}"]`) : null;
      if (template) {
        const icon = document.createElement('span');
        icon.className = 'spec-dropdown__icon';
        icon.append(template.content.cloneNode(true));
        nodes.push(icon);
      }
      const label = document.createElement('span');
      label.className = 'spec-dropdown__label';
      label.textContent = option ? option.textContent.trim() : '';
      nodes.push(label);
      return nodes;
    };

    const build = (select) => {
      const dropdown = dropdownOf(select);
      if (!dropdown) return;
      if (!select.id) select.id = `spec-dropdown-${Math.random().toString(36).slice(2, 9)}`;
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      select.classList.add('spec-dropdown__native');
      let button = dropdown.querySelector('.spec-dropdown__button');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'spec-dropdown__button';
        button.id = `${select.id}-button`;
        button.setAttribute('aria-haspopup', 'listbox');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', `${select.id}-list`);
        const label = dropdown.dataset.labelId;
        button.setAttribute('aria-labelledby', label ? `${label} ${button.id}` : button.id);
        button.innerHTML =
          '<span class="spec-dropdown__value"></span><svg aria-hidden="true" focusable="false" class="spec-dropdown__caret" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        dropdown.append(button);
      }
      let list = dropdown.querySelector('.spec-dropdown__list');
      if (!list) {
        list = document.createElement('ul');
        list.className = 'spec-dropdown__list list-unstyled';
        list.id = `${select.id}-list`;
        list.setAttribute('role', 'listbox');
        list.tabIndex = -1;
        list.hidden = true;
        if (dropdown.dataset.labelId) list.setAttribute('aria-labelledby', dropdown.dataset.labelId);
        dropdown.append(list);
      }
      list.replaceChildren(
        ...Array.from(select.options, (option, index) => {
          const item = document.createElement('li');
          item.id = `${select.id}-option-${index}`;
          item.className = 'spec-dropdown__option';
          item.setAttribute('role', 'option');
          item.dataset.value = option.value;
          item.setAttribute('aria-selected', String(option.selected));
          item.append(...content(option));
          return item;
        })
      );
      button.querySelector('.spec-dropdown__value').replaceChildren(...content(select.options[select.selectedIndex]));
    };

    window.specDropdown = { build, open, close };

    // Selects a page filled before this script ran (the theme joins scripts in its own order) get theirs now.
    document.querySelectorAll('[data-spec-dropdown] select').forEach((select) => {
      if (!dropdownOf(select).querySelector('.spec-dropdown__button')) build(select);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    /*
   * Store change, paired with the hidden option values above. Horizon keeps the later options as
   * chosen when an earlier one changes, so a new diameter can leave a face or layout that does not
   * exist at that size, and the page then shows no variant. After each re-render, move the first
   * option whose chosen value no longer fits to its first value that does; the next re-render
   * repeats this for the options after it.
   */
  (() => {
    if (window.storePickerAutoFix) return;
    window.storePickerAutoFix = true;

    const fixSelection = (picker) => {
      for (const fieldset of picker.querySelectorAll('fieldset')) {
        const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        const checked = inputs.find((input) => input.checked);
        if (!checked || checked.dataset.optionAvailable !== 'false') continue;
        const next = inputs.find((input) => input.dataset.optionAvailable === 'true');
        if (next) next.click();
        return;
      }
      for (const select of picker.querySelectorAll('select')) {
        const selected = select.selectedOptions[0];
        if (!selected || selected.dataset.optionAvailable !== 'false') continue;
        const next = Array.from(select.options).find((option) => option.dataset.optionAvailable === 'true');
        if (next) {
          select.value = next.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    };

    document.addEventListener('shopify:product:select', (event) => {
      const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;
      if (!picker || !event.promise) return;
      // The promise settles after the picker has been re-rendered.
      event.promise.then(() => setTimeout(() => fixSelection(picker), 0)).catch(() => {});
    });

  })();
  } catch(e) { console.error(e); }
})();

})();
